import { render, staticRenderFns } from "./SummaryFullView.vue?vue&type=template&id=04e5e18b&scoped=true&"
import script from "./SummaryFullView.vue?vue&type=script&lang=js&"
export * from "./SummaryFullView.vue?vue&type=script&lang=js&"
import style0 from "./SummaryFullView.vue?vue&type=style&index=0&id=04e5e18b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e5e18b",
  null
  
)

export default component.exports